
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-failed",
      function () {
        return require("private-next-pages/payment-failed/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-failed"])
      });
    }
  